import { useKioskDeviceLocation } from '@/hooks/useKioskDeviceLocation';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Checkbox from '../Checkbox';
import { useFormContext, useWatch } from 'react-hook-form';
import { OrderSendForm } from '@/types/order';
import StoreModal from './StoreModal/StoreModal';
import useToggle from '@/hooks/useToggle';
import { deviceLocationType } from '@/types/data';
import ReceivingMethodModal from '../ReceivingMethodModal';
import GeneralPickUpNotice from './GeneralPickUpNotice';
import ExpressPickUpNotice from './ExpressPickUpNotice';
import OrderPageHeaderSection from './OrderPageHeaderSection';
import { usePickupTime } from '@/hooks/usePickupTime';

// 픽업 문구 케이스
// 1. Today 7:00 PM ~ following 3 days
// 2. Tomorrow 12:00 PM ~ following 3 days
// 3. Next Monday 12:00 PM~ following 3 days

export const PickUpNotice = ({ isShippingAvailable }: { isShippingAvailable: boolean }) => {
  const intl = useIntl();
  const [deviceLocation] = useKioskDeviceLocation();
  const storeModal = useToggle({ showing: false });
  const pickupLocation: deviceLocationType = useWatch({ name: 'pickup_location' }) ?? deviceLocation;
  const { setValue } = useFormContext<OrderSendForm>();
  const receivingModal = useToggle({ showing: false });
  const { quickPickupDate } = usePickupTime();

  useEffect(() => {
    setValue('pickup_location', deviceLocation);
  }, []);

  return (
    <div className="flex flex-col gap-6 px-5 pb-10">
      {/* Header */}
      <OrderPageHeaderSection
        title={intl.formatMessage({ id: 'pick_up_notice_title', defaultMessage: 'Pick-up information' })}
        desc={intl.formatMessage({
          id: 'pick_up_location_desc',
          defaultMessage: 'You can also check the store information in the email receipt sent after completing your order'
        })}
        isShippingAvailable={isShippingAvailable}
        onClick={receivingModal.open}
      />

      <div className="flex flex-col gap-4 pb-4">
        <p className="text-[16px] font-semibold">
          <FormattedMessage id="select_pick_up_location" defaultMessage="Select pick-up location" />
        </p>

        <form className="flex gap-10">
          {deviceLocation === 'hongdae' ? (
            <>
              <div className="flex items-center gap-1">
                <Checkbox
                  checked={pickupLocation === 'hongdae'}
                  label={'Hongdae'}
                  onClick={() => setValue('pickup_location', 'hongdae')}
                />
                <span className="text-[16px] font-semibold text-[#bfbfbf]">(Current store)</span>
              </div>
              <Checkbox checked={pickupLocation === 'myeongdong'} label={'Myeongdong'} onClick={() => storeModal.open()} />
            </>
          ) : (
            <>
              <div className="flex items-center gap-1">
                <Checkbox
                  checked={pickupLocation === 'myeongdong'}
                  label={'Myeongdong'}
                  onClick={() => setValue('pickup_location', 'myeongdong')}
                />
                <span className="text-[16px] font-semibold text-[#bfbfbf]">(Current store)</span>
              </div>
              <Checkbox checked={pickupLocation === 'hongdae'} label={'Hongdae'} onClick={() => storeModal.open()} />
            </>
          )}
        </form>
      </div>

      {/* 일반픽업 notice */}
      <GeneralPickUpNotice />

      {/* 빠른픽업 notice */}
      {/* {quickPickupDate && <ExpressPickUpNotice />} */}

      {storeModal.isShowing && (
        <StoreModal
          location={pickupLocation === 'hongdae' ? 'myeongdong' : 'hongdae'}
          onClose={() => storeModal.close()}
          onClick={() => {
            setValue('pickup_location', pickupLocation === 'hongdae' ? 'myeongdong' : 'hongdae');
            storeModal.close();
          }}
        />
      )}

      {receivingModal.isShowing && <ReceivingMethodModal onClose={receivingModal.close} />}
    </div>
  );
};
